import { ProductSkeleton } from "@common/types/ProductTypes.ts";
import { Products } from "@common/utils/products.ts";
import { Product } from "@common/enums/Product.ts";

export class ProductIdentifier {

    constructor(private readonly productOverrideFromEnv: Product) {
    }

    /**
     * Gets the corresponding product info for a given host
     * @param host - The host domain to match against
     * @returns Object containing product display name, emailSender, URL and logo path
     */
    getProductFromHost(host: string): ProductSkeleton {
        let matchedProduct: ProductSkeleton | null = null;
        // Default to Sellers Direct
        const defaultResult = Products[Product.SellersDirect];
        const domainName = host?.replace('www.', '');
        if (domainName === "" || domainName === undefined) {
            return defaultResult
        }
        for (const product of Object.values(Products)) {
            if (product.knownDomains.some(pattern => domainName.includes(pattern))) {
                matchedProduct = product;
                break;
            }
        }

        // if host includes local host
        if (domainName.includes('localhost')) {
            console.log('Localhost detected, overriding product for emails:', this.productOverrideFromEnv);
            matchedProduct = Products[this.productOverrideFromEnv];

            return matchedProduct;
        }

        return matchedProduct !== null ? matchedProduct : defaultResult;
    }

    /**
     * // XXX we are mixing the concept of dev product override and admin product choice; these should be separated
     * @param strict if true, throw an error if the product is not found
     * @param productName
     */
    // TODO make strict mode default.
    getProductFromOverride(strict: boolean, productName: string): ProductSkeleton {
        let matchedProduct: ProductSkeleton | null = null;

        for (const product of Object.values(Products)) {
            if (product.name.toLowerCase() === productName.toLowerCase()) {
                matchedProduct = product;
                break;
            }
        }

        if (matchedProduct != null) {
            return matchedProduct;
        } else if (strict) {
            throw new Error(`Could not find product for ${productName}`);
        }

        const defaultProduct = Products[Product.SellersDirect];
        return defaultProduct;
    }

    verifyProductName(productName: string): boolean {
        for (const product of Object.values(Products)) {
            if (product.name.toLowerCase() === productName) {
                return true;
            }
        }
        return false;
    }
}